<div class="dialog-header">
  <h2 mat-dialog-title class="custom-dialog-title">
    {{ title | translate }}
  </h2>
  <button mat-icon-button class="close-icon" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="custom-dialog-content">
  <div class="d-flex justify-content-center mb-3">
    <button
      mat-stroked-button
      class="m-button-excel-outline"
      (click)="downloadTemplate()"
    >
      <mat-icon>cloud_download</mat-icon>
      {{ "button.download_template" | translate }}
    </button>
  </div>

  <div
    class="upload-area mb-3"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    [class.dragging]="isDragging"
    [class.has-file]="files.length > 0"
  >
    <div class="form-row" *ngIf="files.length === 0">
      <div class="col m-form form-group mb-0">
        <app-row-file-upload
          [titles]="['general.drag_drop_excel']"
          [multiple]="false"
          [accept]="'.xlsx, .xls, .csv'"
          [class]="'title-size-md title-black title-weight-md icon-primary'"
          (fileChange)="onFileChange($event)"
        >
        </app-row-file-upload>
      </div>
    </div>

    <div class="row" *ngIf="files.length > 0">
      <div class="col">
        <app-file-card
          *ngFor="let file of files; index as i"
          [rowClass]="'excel-file-card'"
          [text]="file.name"
          [enableView]="false"
          [enableDownload]="false"
          (onDelete)="removeFile(i)"
        >
        </app-file-card>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="center" class="mr-0 action">
  <button
    mat-raised-button
    class="m-button-primary"
    (click)="onConfirm()"
    [disabled]="files.length === 0 || isLoading"
  >
    <mat-icon iconPositionEnd>cloud_upload</mat-icon>
    {{ "button.import" | translate }}
  </button>
</mat-dialog-actions>
